import request from '@/service'

export const getSeoConfig = function (params) {
  return request({
    url: '/index/seo',
    method: 'GET',
    params
  })
}
